import React from 'react';

function fmt(v) {
  const n = Number(v);
  if (isNaN(n)) return 'R$ 0';
  return n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 0 });
}

const MESES = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];

export default function ResumoCards({ resumo }) {
  const lucroPositivo = resumo.lucro >= 0;
  const mesLabel = MESES[(resumo.mes || 1) - 1];

  return (
    <div>
      <div style={{ padding: '4px 16px 0', fontSize: 11, color: 'var(--c4)', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '.5px' }}>
        Resumo de {mesLabel}/{resumo.ano}
      </div>
      <div className="sum">
        <div className="sum-it g"><span>Receita</span><p>{fmt(resumo.receita_vendas)}</p></div>
        <div className="sum-it r"><span>Custos</span><p>{fmt(resumo.custo_insumos + resumo.custos_operacionais)}</p></div>
        <div className={`sum-it ${lucroPositivo ? 'b' : 'r'}`}><span>Lucro</span><p>{fmt(resumo.lucro)}</p></div>
        <div className="sum-it y"><span>Estoque</span><p>{resumo.total_unidades} un.</p></div>
      </div>
    </div>
  );
}
